import { type Components } from '@mui/material'
import type { Theme, Tokens } from '../augmentation'
import { spacing } from '../spacing'

export const createMuiTable = ({ palette, typography }: Pick<Tokens, 'palette' | 'typography'>): Components<Theme> => ({
  MuiTableCell: {
    styleOverrides: {
      root: {
        ...typography.body1,
        lineHeight: 1,
        color: palette.text.primary,
        borderBottom: 'none',
        padding: spacing(1.75),
        paddingRight: 0,

        '&:first-of-type': {
          paddingLeft: spacing(3),
        },

        '&:last-of-type': {
          paddingRight: spacing(3),
        },

        '&.MuiTableCell-sizeSmall': {
          paddingTop: spacing(1),
          paddingBottom: spacing(1),
        },
      },
      head: {
        ...typography.body2,
        color: palette.text.tertiary,
        paddingTop: spacing(2),
        paddingBottom: spacing(2),
      },
      stickyHeader: {
        background: palette.pure.light,
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        backgroundColor: palette.background.paper,
        color: palette.text.tertiary,
        borderBottom: `2px solid ${palette.components.divider.line}`,

        // sticky header
        '& .MuiTableCell-root': {
          borderBottom: `2px solid ${palette.components.divider.line}`,
        },
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        backgroundColor: palette.pure.light,

        '.DhlTable--plain &': {
          borderBottom: `1px solid ${palette.grey[250]}`,
        },

        '&.Mui-selected': {
          outline: `2px solid ${palette.pure.dark}`,
          outlineOffset: '-2px',
        },

        'table:not(.DhlTable--plain) &': {
          '&:not(.MuiTableRow-head):nth-of-type(odd)': {
            backgroundColor: palette.grey[200],
          },
        },

        '&.MuiTableRow-hover:hover': {
          cursor: 'pointer',
          backgroundColor: palette.components.dataGrid.hover,
        },
      },

      head: {
        cursor: 'auto',
      },
    },
  },
  MuiTableFooter: {
    styleOverrides: {
      root: {
        borderTop: `1px solid ${palette.components.divider.line}`,

        '& .MuiTableCell-root': {
          backgroundColor: palette.pure.light,
        },
      },
    },
  },
})
